"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFRAME_MESSAGE_SCHEMA_VERSION = exports.OWN_DATA_TYPES = exports.TRACK_MESSAGE = exports.LOG_LEVEL_WARN = exports.ERROR_PREFIX = exports.DATA_TYPE_FILE_TRANSFER = void 0;
exports.getInstance = getInstance;
exports.pushError = pushError;
exports.pushLog = pushLog;
exports.track = track;
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/09/04
 */
const port_1 = require("../messages/port");
const constants_1 = require("../constants");
Object.defineProperty(exports, "OWN_DATA_TYPES", { enumerable: true, get: function () { return constants_1.OWN_DATA_TYPES; } });
const DATA_TYPE_FILE_TRANSFER = "file-transfer";
exports.DATA_TYPE_FILE_TRANSFER = DATA_TYPE_FILE_TRANSFER;
const ERROR_PREFIX = "[pui-partner-comm]";
exports.ERROR_PREFIX = ERROR_PREFIX;
const TRACK_MESSAGE = "file_transfer_message";
exports.TRACK_MESSAGE = TRACK_MESSAGE;
const LOG_LEVEL_WARN = "warn";
exports.LOG_LEVEL_WARN = LOG_LEVEL_WARN;
const IFRAME_MESSAGE_SCHEMA_VERSION = "1.0.0";
exports.IFRAME_MESSAGE_SCHEMA_VERSION = IFRAME_MESSAGE_SCHEMA_VERSION;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function track(id, message, context) {
    /* noop */
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function pushError(id, error, context) {
    /* noop */
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function pushLog(id, messages, context) {
    /* noop */
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getInstance(id) {
    return { instanceId: constants_1.INSTANCE_ID, sendMessage: port_1.sendMessage };
}
//# sourceMappingURL=dependencies.js.map